import * as React from "react";

function SvgWallets(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#wallets_svg__clip0)">
        <path d="M15.82 10.04a2.346 2.346 0 00-2.344 2.343 2.346 2.346 0 002.344 2.344h3.32l.04-.002.039.002c.431 0 .781-.35.781-.781V7.813c0-1.04-.511-1.963-1.295-2.531L16.047.922a.78.78 0 00-1.079-.258l-1.96 1.216-.884-1.496a.781.781 0 00-1.078-.27L3.52 4.688H2.344a.782.782 0 01-.781-.762.782.782 0 01.78-.762H3.79a.781.781 0 100-1.562H2.344c-1.106 0-2.035.77-2.28 1.8a.778.778 0 00-.064.31v13.164A3.129 3.129 0 003.125 20h13.75a3.121 3.121 0 002.965-2.135.781.781 0 10-1.482-.495 1.56 1.56 0 01-1.483 1.068H3.125c-.862 0-1.563-.701-1.563-1.563V6.116c.245.087.508.134.782.134h14.531c.861 0 1.563.701 1.563 1.563v2.226H15.82zm2.617 3.124H15.82a.782.782 0 010-1.562h2.617v1.562zM6.528 4.688l4.654-2.828.831 1.408a.791.791 0 00.113.19l.726 1.23H6.528zm8.14 0l-.865-1.463 1.32-.818 1.39 2.28h-1.846z" />
      </g>
    </svg>
  );
}

export default SvgWallets;
